module.exports = __webpack_public_path__ + "img/foot-logo.ef54fb85.svg";